import React, { useLayoutEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

export default function CookiePolicyPage() {
  const navigate = useNavigate();
  const pageTopRef = useRef(null);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);

    if (pageTopRef.current) {
      pageTopRef.current.scrollIntoView({
        behavior: "instant",
        block: "start",
      });
    }
  }, []);

  return (
    <div ref={pageTopRef} className="cookie-page">
      <style>{`
        .cookie-page { 
          min-height: 100vh;
          background: #f7faf8;
          color: #111827;
          font-family: Inter, "Avenir Next", Arial, sans-serif;
          line-height: 1.65;
        }

        .cookie-shell {
          max-width: 960px;
          margin: 0 auto;
          padding: 34px 24px 72px;
        }

        .cookie-back {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 26px;
          color: #148a58;
          font-size: 14px;
          font-weight: 650;
          text-decoration: none;
        }

        .cookie-back:hover {
          text-decoration: underline;
        }
          .cookie-back-button {
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  font-family: inherit;
}

        .cookie-hero {
          padding: 46px 44px;
          margin-bottom: 26px;
          border-radius: 28px;
          color: #ffffff;
          background: linear-gradient(135deg, #0c6943 0%, #148a58 100%);
          box-shadow: 0 18px 48px rgba(20, 138, 88, 0.16);
        }

        .cookie-hero-label {
          display: inline-flex;
          padding: 6px 13px;
          margin-bottom: 18px;
          border: 1px solid rgba(255, 255, 255, 0.25);
          border-radius: 999px;
          background: rgba(255, 255, 255, 0.13);
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 0.09em;
          text-transform: uppercase;
        }

        .cookie-hero h1 {
          margin: 0 0 13px;
          font-size: clamp(34px, 5vw, 47px);
          font-weight: 760;
          line-height: 1.1;
          letter-spacing: -0.045em;
        }

        .cookie-hero-description {
          max-width: 720px;
          margin: 0;
          color: rgba(255, 255, 255, 0.9);
          font-size: 16px;
        }

        .cookie-meta {
          display: flex;
          flex-wrap: wrap;
          gap: 11px;
          margin-top: 30px;
        }

        .cookie-meta-item {
          padding: 9px 13px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          border-radius: 12px;
          background: rgba(255, 255, 255, 0.11);
          color: rgba(255, 255, 255, 0.94);
          font-size: 13px;
        }

        .cookie-card {
          padding: 30px 32px;
          margin-bottom: 17px;
          border: 1px solid #e3ebe6;
          border-radius: 22px;
          background: #ffffff;
          box-shadow: 0 5px 22px rgba(17, 24, 39, 0.035);
        }

        .cookie-card h2 {
          display: flex;
          align-items: center;
          gap: 12px;
          margin: 0 0 16px;
          color: #111827;
          font-size: 21px;
          font-weight: 720;
          letter-spacing: -0.02em;
        }

        .cookie-number {
          flex-shrink: 0;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 34px;
          height: 34px;
          border-radius: 11px;
          background: #e9f6ef;
          color: #148a58;
          font-size: 14px;
          font-weight: 750;
        }

        .cookie-card p {
          margin: 0 0 13px;
          color: #374151;
          font-size: 15px;
        }

        .cookie-card p:last-child {
          margin-bottom: 0;
        }

        .cookie-list {
          margin: 8px 0 0;
          padding-left: 21px;
          color: #374151;
          font-size: 15px;
        }

        .cookie-list li {
          margin-bottom: 9px;
          padding-left: 3px;
        }

        .cookie-highlight {
          padding: 18px 20px;
          margin-top: 18px;
          border-left: 4px solid #148a58;
          border-radius: 13px;
          background: #f1faf5;
          color: #244536;
          font-size: 14px;
        }

        .cookie-warning {
          padding: 18px 20px;
          margin-top: 18px;
          border-left: 4px solid #d59b25;
          border-radius: 13px;
          background: #fffaf0;
          color: #594019;
          font-size: 14px;
        }

        .cookie-table-wrapper {
          width: 100%;
          margin-top: 20px;
          overflow-x: auto;
          border: 1px solid #e3ebe6;
          border-radius: 16px;
        }

        .cookie-table {
          width: 100%;
          min-width: 760px;
          border-collapse: collapse;
          background: #ffffff;
          font-size: 14px;
        }

        .cookie-table th {
          padding: 14px 15px;
          border-bottom: 1px solid #e3ebe6;
          background: #f1f7f3;
          color: #24372d;
          font-size: 13px;
          font-weight: 720;
          text-align: left;
        }

        .cookie-table td {
          padding: 15px;
          border-bottom: 1px solid #edf2ee;
          color: #374151;
          vertical-align: top;
        }

        .cookie-table tr:last-child td {
          border-bottom: none;
        }

        .cookie-tag {
          display: inline-flex;
          padding: 4px 9px;
          border-radius: 999px;
          background: #e9f6ef;
          color: #0f6c45;
          font-size: 12px;
          font-weight: 720;
          white-space: nowrap;
        }

        .cookie-tag-third-party {
          display: inline-flex;
          padding: 4px 9px;
          border-radius: 999px;
          background: #edf3ff;
          color: #264f98;
          font-size: 12px;
          font-weight: 720;
          white-space: nowrap;
        }

        .cookie-link {
          color: #148a58;
          font-weight: 600;
          text-decoration: underline;
          text-underline-offset: 2px;
        }

        .cookie-contact {
          padding: 30px 32px;
          margin-top: 20px;
          border-radius: 22px;
          background: #10271e;
          color: #ffffff;
        }

        .cookie-contact h2 {
          margin: 0 0 10px;
          font-size: 21px;
          letter-spacing: -0.02em;
        }

        .cookie-contact p {
          margin: 0 0 14px;
          color: rgba(255, 255, 255, 0.82);
          font-size: 15px;
        }

        .cookie-contact a {
          color: #ffffff;
          font-weight: 650;
          text-decoration: underline;
          text-underline-offset: 3px;
        }

        .cookie-footer {
          padding-top: 30px;
          color: #64748b;
          font-size: 13px;
          text-align: center;
        }

        @media (max-width: 640px) {
          .cookie-shell {
            padding: 20px 15px 48px;
          }

          .cookie-hero {
            padding: 32px 23px;
            border-radius: 21px;
          }

          .cookie-card,
          .cookie-contact {
            padding: 23px 20px;
            border-radius: 18px;
          }

          .cookie-card h2 {
            align-items: flex-start;
            font-size: 19px;
          }
        }
      `}</style>

      <main className="cookie-shell">
  <button
  type="button"
  className="cookie-back cookie-back-button"
  onClick={() => navigate(-1)}
>
  ← Back to EcoTrack
</button>

        <header className="cookie-hero">
          <div className="cookie-hero-label">Legal Information</div>

          <h1>Cookie Policy</h1>

          <p className="cookie-hero-description">
            This Cookie Policy explains how EcoTrack uses cookies and similar
            technical technologies, including browser storage used for secure
            authentication and third-party technologies that may operate when
            a user accesses Stripe-hosted payment checkout.
          </p>

          <div className="cookie-meta">
            <div className="cookie-meta-item">Last updated: 31 May 2026</div>
            <div className="cookie-meta-item">Viridis by Serap Cevirgen</div>
            <div className="cookie-meta-item">VAT No. 04191120130</div>
          </div>
        </header>

        <section className="cookie-card">
          <h2>
            <span className="cookie-number">1</span>
            Who we are
          </h2>

          <p>
            EcoTrack is a digital ESG self-assessment and support service
            operated by <strong>Viridis by Serap Cevirgen</strong>.
          </p>

          <p>
            Questions concerning this Cookie Policy may be sent to{" "}
            <a
              className="cookie-link"
              href="mailto:serap.cevirgen@viridisconsultancy.com"
            >
              serap.cevirgen@viridisconsultancy.com
            </a>
            .
          </p>
        </section>

        <section className="cookie-card">
          <h2>
            <span className="cookie-number">2</span>
            Scope of this Policy
          </h2>

          <p>
            This Policy applies to the EcoTrack application and its connected
            payment flow.
          </p>

          <p>
            It explains the technical technologies used directly on EcoTrack
            application pages and the involvement of third-party hosted
            checkout services when a user chooses to purchase access to
            EcoTrack.
          </p>

          <p>
            The main Viridis website may have separate technical configurations
            and should be assessed independently from the EcoTrack application.
          </p>
        </section>

        <section className="cookie-card">
          <h2>
            <span className="cookie-number">3</span>
            What cookies and similar technologies are
          </h2>

          <p>
            Cookies are small text files that may be stored on a user&apos;s
            device when an online service is accessed.
          </p>

          <p>
            Similar technologies include browser storage tools such as Local
            Storage, Session Storage and IndexedDB. These technologies may be
            used to maintain login sessions, protect secure functionality,
            support technical operation and enable requested payment services.
          </p>
        </section>

        <section className="cookie-card">
          <h2>
            <span className="cookie-number">4</span>
            Technologies used directly by EcoTrack
          </h2>

          <p>
            At the date of this Policy, EcoTrack uses technical browser-storage
            technologies necessary to provide secure authentication and core
            application functionality.
          </p>

          <p>
            In particular, EcoTrack uses Firebase / Google Cloud services for
            account authentication and related technical operation. These
            technologies may store authentication-session information and
            technical service information in the user&apos;s browser, including
            through IndexedDB.
          </p>

          <div className="cookie">
            EcoTrack application pages do not currently intentionally activate
            non-essential analytics, advertising, marketing or profiling
            technologies. If this changes, this Policy will be updated and,
            where legally required, an appropriate consent mechanism will be
            provided before those technologies are activated.
          </div>

          <div className="cookie-table-wrapper">
            <table className="cookie-table">
              <thead>
                <tr>
                  <th>Technology or service</th>
                  <th>Type</th>
                  <th>Purpose</th>
                  <th>Retention criterion</th>
                  <th>Status</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>
                    <strong>Firebase Authentication</strong>
                    <br />
                    Example technical storage: authentication-session data
                  </td>
                  <td>Browser storage, including IndexedDB</td>
                  <td>
                    To recognise authenticated users, maintain secure login
                    status and allow access to protected EcoTrack features.
                  </td>
                  <td>
                    Retained according to the authentication-session
                    configuration, until logout, expiry or deletion of browser
                    storage.
                  </td>
                  <td>
                    <span className="cookie-tag">Necessary</span>
                  </td>
                </tr>

                <tr>
                  <td>
                    <strong>Firebase technical operation</strong>
                    <br />
                    Example technical storage: heartbeat information
                  </td>
                  <td>IndexedDB or comparable technical storage</td>
                  <td>
                    To support the technical operation, reliability and
                    communication of Firebase services used by EcoTrack.
                  </td>
                  <td>
                    Retained only according to the technical operation of the
                    relevant Firebase service.
                  </td>
                  <td>
                    <span className="cookie-tag">Necessary</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <section className="cookie-card">
          <h2>
            <span className="cookie-number">5</span>
            Stripe-hosted payment checkout
          </h2>

          <p>
            When a user chooses to purchase EcoTrack access, the user may be
            redirected to a payment checkout page hosted and operated by{" "}
            <strong>Stripe</strong>.
          </p>

          <p>
            On Stripe-hosted checkout pages, Stripe may use cookies and similar
            technologies for purposes including payment processing, secure
            checkout functionality, fraud-risk assessment and prevention of
            automated abuse or card-testing activity.
          </p>

          <p>
            Stripe may also load CAPTCHA-based protection, including{" "}
            <strong>hCaptcha</strong>, where required for checkout security and
            fraud-prevention purposes.
          </p>

          <div className="cookie">
            Technologies operating on Stripe-hosted domains are determined and
            controlled by Stripe under Stripe&apos;s own cookie and privacy
            information. EcoTrack does not control the individual cookies or
            storage durations set by Stripe on its hosted checkout pages.
          </div>

          <div className="cookie-table-wrapper">
            <table className="cookie-table">
              <thead>
                <tr>
                  <th>Technology or service</th>
                  <th>Where it operates</th>
                  <th>Purpose</th>
                  <th>Retention criterion</th>
                  <th>Status</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>
                    <strong>Stripe Checkout</strong>
                  </td>
                  <td>Stripe-hosted payment pages</td>
                  <td>
                    To provide secure payment checkout and process subscription
                    purchases initiated by the user.
                  </td>
                  <td>
                    Determined by Stripe in accordance with its own cookie and
                    privacy information.
                  </td>
                  <td>
                    <span className="cookie-tag-third-party">
                      Stripe controlled
                    </span>
                  </td>
                </tr>

                <tr>
                  <td>
                    <strong>Stripe fraud-prevention functionality</strong>
                    <br />
                    Including hCaptcha where activated by Stripe
                  </td>
                  <td>
                    Stripe-hosted payment pages and related security services
                  </td>
                  <td>
                    To assess fraud risk, prevent automated abuse and protect
                    the payment process.
                  </td>
                  <td>
                    Determined by Stripe in accordance with its own cookie and
                    privacy information.
                  </td>
                  <td>
                    <span className="cookie-tag-third-party">
                      Stripe controlled
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <p style={{ marginTop: 18 }}>
            Further information about technologies used by Stripe is available
            through Stripe&apos;s{" "}
            <a
              className="cookie-link"
              href="https://stripe.com/it/cookie-settings"
              target="_blank"
              rel="noopener noreferrer"
            >
              cookie settings and information page
            </a>
            .
          </p>
        </section>

        <section className="cookie-card">
          <h2>
            <span className="cookie-number">6</span>
            Consent and user choices
          </h2>

          <p>
            EcoTrack does not currently request consent for the technical
            technologies used directly on its application pages because those
            technologies are used for authentication, secure access and core
            service operation requested by the user.
          </p>

          <p>
            Users may configure their browser to block or delete cookies and
            browser-storage technologies. However, disabling or deleting
            necessary technical storage may log the user out or prevent
            protected EcoTrack functionality from operating correctly.
          </p>

          <p>
            Where a user accesses Stripe-hosted checkout, Stripe&apos;s own
            information and available controls apply to technologies operating
            on Stripe domains.
          </p>
        </section>

        <section className="cookie-card">
          <h2>
            <span className="cookie-number">7</span>
            Third-party services involved
          </h2>

          <p>
            Depending on the functionality accessed by the user, EcoTrack may
            rely on the following third-party services:
          </p>

          <ul className="cookie-list">
            <li>
              <strong>Firebase / Google Cloud</strong>, for account
              authentication and technical application functionality;
            </li>

            <li>
              <strong>Stripe</strong>, for hosted payment checkout and
              payment-security functionality;
            </li>

            <li>
              <strong>hCaptcha</strong>, where loaded by Stripe as part of its
              fraud-prevention or bot-detection measures during checkout.
            </li>
          </ul>
        </section>

        <section className="cookie-card">
          <h2>
            <span className="cookie-number">8</span>
            Changes to this Policy
          </h2>

          <p>
            This Cookie Policy may be updated from time to time to reflect
            legal, technical or operational changes affecting EcoTrack or its
            connected checkout services.
          </p>

          <p>
            The date shown at the top of this page identifies the most recent
            update.
          </p>
        </section>

        <section className="cookie-contact">
          <h2>Contact</h2>

          <p>
            Questions concerning this Cookie Policy or the technical
            technologies used by EcoTrack may be sent to:
          </p>

          <a href="mailto:serap.cevirgen@viridisconsultancy.com">
            serap.cevirgen@viridisconsultancy.com
          </a>
        </section>

        <footer className="cookie-footer">
          © 2026 Viridis by Serap Cevirgen · EcoTrack
        </footer>
      </main>
    </div>
  );
}
